import React, { useEffect, useState, useRef } from "react";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  TextInputBase,
} from "@reusejs/react";
import ResendCode from "../../../app/components/authentication/ResendCode";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { setBankerLoginDate, setBankerTokens, setBankerUser } from "store";
import { intiateLoginWithOtp, loginWithOtp, getUser, getTeams } from "services";
import { OTPInputComponent } from "../web/Auth/OTPInputComponent";
import { DateTime } from "luxon";

export default function BankerLoginForm(props: any) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [emailVerified, setEmailVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    return () => {
      isSubmittingRef.current = false;
    };
  }, []);
  const form = useBetaForm({
    email: "",
  });

  const loginForm = useBetaForm({
    email: "",
    otp: "",
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
  };

  const loginForm_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    otp: {
      presence: {
        allowEmpty: false,
        message: "^OTP can't be blank",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
    loginForm.setValidationRules(loginForm_constraints);
  }, []);

  const handleEmailSubmission = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsLoading(true);
    try {
      form.value.email = form.value.email.trim().toLowerCase();
      if (form.validate()) {
        await intiateLoginWithOtp(form);
        loginForm.setField("email", form.value.email);
        setEmailVerified(true);
      }
    } catch (error: any) {
      console.log("Error in email submission", error);
    } finally {
      isSubmittingRef.current = false;
      setIsLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setVerifyLoading(true);
    try {
      if (loginForm.validate()) {
        const data: any = await loginWithOtp(loginForm);
        dispatch(setBankerTokens(data));
        const user = await getUser();
        dispatch(setBankerUser(user));
        const loginDateIST = DateTime.now()
          .setZone("Asia/Kolkata")
          .toFormat("yyyy-MM-dd");
        dispatch(setBankerLoginDate({ loginDate: loginDateIST }));
        await new Promise((resolve) => setTimeout(resolve, 2000));
        router.push("/");
      }
    } catch (error: any) {
      console.log("check here error", error);
    } finally {
      isSubmittingRef.current = false;
      setVerifyLoading(false);
    }
  };

  const handleResendCode = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setResendLoading(true);
    try {
      console.log("check here form ", form.value);
      await intiateLoginWithOtp(form);
    } catch (error) {
      console.log("Error in resend code", error);
    } finally {
      isSubmittingRef.current = false;
      setResendLoading(false);
    }
  };

  return (
    <div className="my-6 pb-[103px]">
      {!emailVerified ? (
        <>
          <p className="text-3xl font-openSans font-normal">Get Started Now</p>
          <p className="font-openSans text-xs text-login-color mt-1 mb-26">
            Enter your details to access your account
          </p>

          <div className="space-y-2 mt-[100px]">
            <input
              type="text"
              placeholder="Enter email or Mobile number"
              value={form.getField("email")}
              onChange={(e) => {
                const input = e.target;
                const start = input.selectionStart;
                const end = input.selectionEnd;

                const lower = input.value.toLowerCase();
                form.setField("email", lower);
                requestAnimationFrame(() => {
                  input.setSelectionRange(start, end);
                });
              }}
              onKeyDown={(e: any) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleEmailSubmission();
                }
              }}
              className="bg-white border-none focus:ring-brand-orange h-10 lg:h-12 p-2 lg:p-3   w-full font-openSans font-semibold text-web-body-md leading-4 text-[#A1A0A0]"
            />
            {form.errors.get("email") ? (
              <p className="mt-2 text-sm text-red-500">
                {form.errors.get("email")[0]}
              </p>
            ) : null}
          </div>
          <div className="mt-[44px]">
            <ButtonBase
              variant="primary"
              label={isLoading ? "Sending OTP..." : "Next"}
              onClick={handleEmailSubmission}
              disabled={isLoading}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-login-color hover:bg-[#3a3a3a]",
                textColor: "text-white",
                border: "any",
                width: "w-full",
                padding: "px-4 py-3",
                borderRadius: "rounded-xl",
              }}
            />
          </div>

          <hr
            style={{ width: "100%", marginTop: "71px", marginBottom: "24px" }}
          />
          <p className="font-openSans text-xs text-login-color text-center">
            By Logging in, I Agree To The{" "}
            <span className="underline font-openSans hover:cursor-pointer">
              Privacy Policy & Terms And Conditions
            </span>
          </p>
        </>
      ) : (
        <>
          <p className="text-3xl font-openSans font-normal mb-[45px]">
            Verify Details
          </p>
          <p className="mb-8">
            OTP sent to {form.getField("email")}{" "}
            <span
              onClick={() => {
                setEmailVerified(false);
              }}
              className="underline cursor-pointer"
            >
              Edit
            </span>
          </p>

          <OTPInputComponent
            bgColor="bg-white"
            otpEntered={loginForm.getField("otp")}
            setOtpEntered={(val) => loginForm.setField("otp", val)}
            onSubmit={handleSubmit}
          />
          {loginForm.errors.get("email") && (
            <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
              {loginForm.errors.get("email")[0]}
            </p>
          )}
          {loginForm.errors.get("otp") && (
            <p className="text-brand-textRed  mt-1 text-web-body-sm ml-2">
              {loginForm.errors.get("otp")[0]}
            </p>
          )}

          <div className="text-sm my-10">
            <ResendCode resendCallback={handleResendCode} />
          </div>

          <ButtonBase
            variant="primary"
            label={verifyLoading ? "Verifying..." : "Next"}
            onClick={handleSubmit}
            disabled={verifyLoading}
            buttonBaseClasses={{
              font: "text-sm font-medium",
              backgroundColor: "bg-login-color hover:bg-[#3a3a3a]",
              textColor: "text-white",
              border: "any",
              width: "w-full",
              padding: "px-4 py-3",
              borderRadius: "rounded-xl",
            }}
          />
        </>
      )}
    </div>
  );
}
